var _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLoanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4999 25.5C30.4999 25.5 18.1079 34.399 18.5589 46.82C18.7149 51.11 22.2629 54.5 26.5559 54.5C32.0109 54.5 39.9879 54.5 45.4429 54.5C49.7359 54.5 53.2839 51.11 53.4399 46.82C53.8919 34.399 41.4999 25.5 41.4999 25.5",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.445 17.5C38.752 16.309 37.477 15.5 36 15.5C34.523 15.5 33.248 16.309 32.555 17.5H27.5L30.5 25.5H41.5L44.5 17.5H39.445Z",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33V47",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40H43",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 69,
    height: 69,
    rx: 34.5,
    stroke: "#131313",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLoanIcon);
export default __webpack_public_path__ + "static/media/new-loan-icon.0ad0c6695468658deec6935a7677c09d.svg";
export { ForwardRef as ReactComponent };